import type { FormControlSetting, Setting } from '@/app/editor/iframe/atom/Atom.model';
import { GpElement } from '@/app/editor/iframe/atom/element/GpElement';
import buttonInfo from '@/app/editor/sidebar/elementsInfo/button';

const FormControlSettings: Array<FormControlSetting> = [
  {
    type: 'html:attr',
    name: 'editLink',
    targetSelector: '.gf_button',
    property: 'href',
    relatedField: 'scrollSpeed',
  },
  {
    type: 'html:attr',
    name: 'scrollSpeed',
    targetSelector: '.gf_button',
    property: 'data-scroll-speed',
  },
  {
    type: 'html:attr',
    name: 'linkTarget',
    targetSelector: '.gf_button',
    property: 'target',
  },
  {
    type: 'html:muti',
    name: 'editText',
    targetSelectors: ['.gf_button > span', '.gf_button'],
    property: '',
  },
  {
    type: 'custom:align',
    name: 'alignment',
    targetSelector: '.elm',
    property: '',
  },
  {
    type: 'html:stretch',
    name: 'stretch',
    targetSelector: '.elm',
    attrStoredSelector: '.elm',
    property: 'gf_button-stretch',
  },
  {
    type: 'css',
    name: 'width',
    targetSelector: '.gf_button',
    property: 'width',
  },
  {
    type: 'css',
    name: 'height',
    targetSelector: '.gf_button',
    property: 'height',
  },
  {
    type: 'css',
    name: 'font-size',
    targetSelector: '.gf_button',
    property: 'font-size',
    require: true,
  },
  {
    type: 'css',
    name: 'font',
    targetSelector: '.gf_button',
    property: 'font-family',
  },
  {
    type: 'css',
    name: 'textTransform',
    targetSelector: '.gf_button',
    property: 'text-transform',
    require: true,
  },
  {
    type: 'css',
    name: 'button-color',
    fieldType: 'color',
    targetSelector: '.gf_button',
    property: 'background-color',
  },
  {
    type: 'css',
    name: 'text-color',
    fieldType: 'color',
    targetSelector: '.gf_button',
    property: 'color',
  },
  {
    type: 'css',
    name: 'button-color-hover',
    targetSelector: '.gf_button:hover',
    fieldType: 'color',
    property: 'background-color',
  },
  {
    type: 'css',
    name: 'text-color-hover',
    targetSelector: '.gf_button:hover',
    fieldType: 'color',
    property: 'color',
  },
  {
    type: 'html:extraClass',
    name: 'extra_class',
    targetSelector: '.gf_button',
    property: 'data-exc',
    default_value: '',
  },
  {
    type: 'custom:condition',
    name: 'buttonHover',
    targetSelector: '',
    links: 'button-color-hover,text-color-hover',
    condition: {
      // eslint-disable-next-line quotes
      syntax: `"#{button-color-hover}" != "undefined" || "#{text-color-hover}" != "undefined"`,
      success: 1,
      fail: 0,
    },
    property: '',
  },
];
/**
 * Button Atom Element
 */
export class GpButton extends GpElement {
  public $el: JQuery;

  /**
   * [Hook] [override]
   * @param settings ()
   * @returns settings data
   */
  formatSettingAtom(settings: Array<Setting>): Array<Setting> {
    return settings.length > 0 ? settings : buttonInfo.settings;
  }

  /**
   * [Hook] [override]
   * @returns Name
   */
  getLabel(): string {
    return this.$el.attr('data-label') || buttonInfo.name;
  }

  /**
   * [Hook] [override]
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || buttonInfo.slug;
  }
  /**
   * getClassName
   * @returns Class name of element
   */
  getTargetClassSelector(): string {
    return '.' + buttonInfo.class;
  }
  /**
   * getFormControlSettings;
   * @returns setting read/write from left-sidebar to live page
   */
  getFormControlSettings(): Array<FormControlSetting> {
    return FormControlSettings;
  }
}
